<template>
  <Marco>
    <div class="cl one-col position" slot="content">
      <div class="col2" />

      <div class="col1">
        <div class="main-title">
          <h1 class="title">{{ step.pregunta }}</h1>
        </div>

        <div class="field-row">
          <div class="field">
            <div class="wysiwyg type2">
              <p>{{ step.mensaje }}</p>
              <p>
                Lo sentimos. con los datos facilitados necesitamos contactar
                contigo.
              </p>
              <p align="justify">
                Por favor, llámanos al
                <a href="tel:915948800">915948800</a> o, si lo prefieres,
                déjanos tus datos en el enlace
                <a href="#" @click.prevent="popUpConfirmTel = true">
                  <span class="noSeparar">TE LLAMAMOS</span>
                </a>
                y nuestro Centro de Atención al Cliente se pondrá en contacto
                contigo a la mayor brevedad posible.
              </p>
              <p>Disculpa las molestias. Gracias.</p>
            </div>
            <TeLlamamos v-if="popUpConfirmTel" @close="confirmTel(false)" />
          </div>
        </div>
      </div>
    </div>
    <a slot="botonAtras" href="#" @click.prevent="inicio">Inicio</a>
  </Marco>
</template>

<script>
export default {
  store: ["step"],

  data() {
    return {
      popUpConfirmTel: false
    };
  },

  mounted() {
    console.log("entra en aviso");
  },

  methods: {
    confirmTel(val) {
      this.popUpConfirmTel = val;
    },
    inicio() {
      this.$router.push({
        name: "init"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.noSeparar {
  white-space: nowrap;
}
</style>
